import { useContext } from "react";

import { SlideData } from "../interfaces/question.interface";
import { SlideDataContext } from "../contexts/slideDataContext";

/**
 * Gets the current slide data.
 *
 * Searches the SlideDataContext for the first element where $completed is false.
 *
 * If all questions are completed return the last one.
 *
 * @listens SlideDataContext
 * @return {SlideData} SlideData.
 */
const useCurrentSlideData = (): SlideData => {
  const { quizSlideDataSequence } = useContext(SlideDataContext);
  const currentSlideData: SlideData | undefined = quizSlideDataSequence.find(
    (slideData: SlideData) => slideData.completed === false
  );
  if (currentSlideData === undefined)
    return quizSlideDataSequence[quizSlideDataSequence.length - 1];

  return currentSlideData;
};

export default useCurrentSlideData;
